<div [hidden]="!(data().requirements$ | async)?.data?.length" class="submittal-match-breakdown_requirements" [ngClass]="{ 'mb-4': !data().isOther && !showRequirementsOverrideIndicator() }">
    <h4>{{data().title}}</h4>

    @if (data().warning && !data().userCompletedAssessment) {
        <p class="warning">
            <mat-icon inline="true">sentiment_very_dissatisfied</mat-icon>
            The candidate has not completed the required skills assessment for this position.
        </p>
    }

    @if (data().subtitle) {
        <p [innerHTML]="data().subtitle | sanitizer" class="mb-2"></p>
    }

    @if (data()?.otherAssessmentNote) {
        <p
            [innerHTML]="data().otherAssessmentNote | sanitizer"
            class="other-assessment-note"
            data-qa-id="OtherAssessmentNote">
        </p>
    }

    <nova-grid #grid
        [data]="data().requirements$ | async"
        [filterable]="false"
        [needToolbar]="false"
        [resizable]="false"
        [autoFitColumns]="false"
        [pageable]="false"
        [scrollable]="'none'"
        [selectable]="{ enabled: false, mode: 'single' }">

        <nova-grid-column
            field="overrideIndicator"
            title=""
            [template]="overrideIndicatorTemplate"
            width="15"
            [hidden]="!showRequirementsOverrideIndicator()">
            <ng-template #overrideIndicatorTemplate let-dataItem="dataItem">
                @if (dataItem.isAdditionalRequirement) {
                    <span class="override-indicator">+</span>
                }
            </ng-template>
        </nova-grid-column>

        @if (data().isSkills) {
            <nova-grid-column
                field="categoryName"
                title="Category"
                [template]="categoryTemplate"
                [width]="130">
                <ng-template #categoryTemplate let-dataItem="dataItem">
                    {{dataItem.categoryName}}
                </ng-template>
            </nova-grid-column>
        }

        <nova-grid-column
            field="name"
            [title]="data().header"
            [template]="nameTemplate"
            [width]="180">
            <ng-template #nameTemplate let-dataItem="dataItem">
                {{dataItem?.name}}
                @if (shouldShowAlternativeCertifications(dataItem)) {
                    <span> {{getAlternativesDisplayText(dataItem)}}</span>
                }
                @if (dataItem.workHistoryGap) {
                    <div>
                        <a class="nova__link"
                        target="_blank"
                        routerLink="/recruiting/candidates/{{data().candidateId}}/new-profile/work-history">
                        View work history
                        </a>
                    </div>
                }
                <ng-container>
                    @if (!(!dataItem.otherNotes?.trim())) {
                        <div class="other-notes" data-qa-id="YearsExperienceNotes">
                            (Note: {{dataItem.otherNotes}})
                        </div>
                    }
                </ng-container>
            </ng-template>
        </nova-grid-column>

        @if (!data().isOther) {
            <nova-grid-column
                field="candidateHasMetRequirement"
                title="Match?"
                [template]="matchTemplate"
                [width]="230">
                <ng-template #matchTemplate let-dataItem="dataItem">
                    <nova-match-breakdown-report-icon [isUnableToValidate]="dataItem.isUnableToValidate" [isMatchedClass]="dataItem.isMatchedClass" [displayText]="dataItem.displayText"></nova-match-breakdown-report-icon>
                    <span class="other-assessment">{{dataItem.otherAssessment}}</span>
                </ng-template>
            </nova-grid-column>
        }

        @if (!data().isOther && !isJobScreen()) {
            <nova-grid-column
                field="explanation"
                title="Recruiter Explanation"
                [template]="explanationTemplate">
                <ng-template #explanationTemplate let-dataItem="dataItem">
                    {{dataItem?.explanation}}
                </ng-template>
            </nova-grid-column>
        }

        @if (data().isOther) {
            <nova-grid-column
                title="Notes"
                [template]="otherNotesTemplate">
                <ng-template #otherNotesTemplate let-dataItem="dataItem">
                    @for (requirement of dataItem.requirements; track requirement) {
                        <div>{{requirement}}</div>
                    }
                </ng-template>
            </nova-grid-column>
        }
    </nova-grid>
</div>
